import { t } from "@redotech/redo-i18n";
import { assertNever } from "@redotech/util/type";

export enum GeneralAiTab {
  GENERAL = "general",
  COMMUNICATION_STYLE = "communication-style",
  PRODUCT_RECOMMENDATIONS = "product-recommendations",
}

export const GENERAL_AI_TAB_QUERY = "tab";

export function generalAiTabToFriendly(tab: GeneralAiTab): string {
  switch (tab) {
    case GeneralAiTab.GENERAL:
      return t("General");
    case GeneralAiTab.COMMUNICATION_STYLE:
      return t("Communication Style");
    case GeneralAiTab.PRODUCT_RECOMMENDATIONS:
      return t("Product Recommendations");
    default:
      return assertNever(tab);
  }
}
